
import apiService from "./apiServices";

export const createDriverInfo = async (formData, token) => {
  try {

    const response = await apiService('/driverInfo/', 'POST', formData, null, token);

    return response;
  } catch (error) {
    throw new Error(error.message || 'Creating organization is failed. Please try again.');
  }
}

export const updateDriverInfo = async (formData, token) => {
  try {

    const response = await apiService(`/driverInfo/`, 'PUT', formData, null, token);

    return response;
  } catch (error) {
    throw new Error(error.message || 'Updating organization is failed. Please try again.');
  }
}

export const getDriverInfoById = async (quoteId, token) => {
  try {

    const response = await apiService(`/driverInfo/${quoteId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getDriverNameInfoById = async (quoteId, token) => {
  try {

    const response = await apiService(`/driverInfo/NameBygpid/${quoteId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getAllDriverInfo = async (generalPartyId,token) => {
  try {

    const response = await apiService(`/driverInfo/bygpid/${generalPartyId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const deleteDriverInfoById = async (quoteId, token) => {
  try {

    const response = await apiService(`/driverInfo/${quoteId}`, 'DELETE', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const saveDriver = async (formData, token) => {
  try {
    const response = await apiService('/driver/save', 'POST', formData, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Saving driver is failed. Please try again.');
  }
}

export const getDriver = async (token, page, size) => {
  try {
    const response = await apiService(`/driver/all?page=${page}&size=${size}`, 'GET', null, null, token);

    return response;
  } catch (error) {
    throw new Error(error.message || 'Saving driver is failed. Please try again.');
  }
}

export const getDriverByIdServices = async (id, token) => {
  try {
    const response = await apiService(`/driver/${id}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Saving driver is failed. Please try again.');
  }
}

export const updatedDriverServices = async (formData, token) => {
  try {
    const response = await apiService(`/driver/update`, 'PUT', formData, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Saving driver is failed. Please try again.');
  }
}

export const policyDriverDetailServices = async (id, token) => {
  try {
    const response = await apiService(`/driver/${id}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Driver Details is failed. Please try again.');
  }
}

export const getAllViolations = async (token) => {
  try {
    const response = await apiService(`/accident-violation/`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Fetching violations is failed. Please try again.');
  }
}

export const saveViolations = async (formData, token) => {
  try {
    const response = await apiService('/violation/', 'POST', formData, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Saving violations is failed. Please try again.');
  }
}
export const getViolationsByIdServices = async (id, token) => {
  try {
    const response = await apiService(`/violation/${id}`, 'GET', null, null, token);
    // console.log("response",response)
    return response;
  } catch (error) {
    throw new Error(error.message || 'Fetching violations is failed. Please try again.');
  }
}

export const updatedViolationServices = async (formData, token) => {
  try {
    const response = await apiService(`/violation/`, 'PUT', formData, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Updating violation is failed. Please try again.');
  }
}

export const deleteViolationById = async (violationId, token) => {
  try {

    const response = await apiService(`/violation/${violationId}`, 'DELETE', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Delete service is failed. Please try again.');
  }
}